export { default as useProductStyles } from './useProductStyles';
